import { render } from "./New.vue?vue&type=template&id=c3c53bbc&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=c3c53bbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3c53bbc"

export default script